export type Config = {
  keys: {
    announcement: string;
  };
};

const config = {
  keys: {
    announcement: "announcement",
    klaviyoId: "",
    recently_viewed: "recently_viewed",
  },
  attributes: {
    isGwp: "isGWP",
  },
  functions: {
    updateCustomer: "https://australia-southeast1-stunning-hull-385405.cloudfunctions.net/customerDetails",
  },
  stores: {
    "roler-clothing": {
      shopify_domain: "roler-clothing",
      storefront_access_token: "3f7dac9f36d0ede7483b3da576106634",
      url: "https://roler.com.au",
    },
  },
};

export default config;
